import { useCompare } from '@/js/vue/composable/compare.ts';

export function initCompare(): void {
  const buttons = document.querySelectorAll<HTMLButtonElement>('.js-compare-toggle');

  for (const btn of buttons) {
    btn.addEventListener('click', () => {
      void handleCompareToggle(btn);
    });
  }
}

const { add, remove } = useCompare();
async function handleCompareToggle(btn: HTMLButtonElement): Promise<void> {
  const productId = Number(btn.dataset.productId);

  try {
    if (btn.classList.contains('active')) {
      await remove(productId);
      btn.classList.remove('active');
    }
    else {
      await add(productId);
      btn.classList.add('active');
    }
  }
  catch (err) {
    console.error('Ошибка', err);
  }
}
